import styled, { css } from 'styled-components'

import { ScrollContent } from '@components/common/ScrollContent'
import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Main = styled.div`
  display: flex;
  gap: var(--space-200);
  flex-direction: column;

  ${mediaQueries.tablet} {
    flex-direction: row;
    max-height: 324px;
  }
`

export const OptionsList = styled(ScrollContent)`
  display: flex;
  flex-direction: column;
  min-width: 146px;
  padding-bottom: var(--space-100);
`

export const OptionsSelect = styled.div`
  width: 100%;
  padding: var(--space-300) var(--space-300) var(--space-200) var(--space-300);
`

export const OptionsListItem = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  padding: var(--space-200) var(--space-200) var(--space-200) var(--space-300);
  margin-right: var(--space-100);
  cursor: pointer;

  &:hover {
    background: var(--bg-secondary);
  }

  ${({ $selected }) =>
    $selected &&
    css`
      font-weight: var(--font-weight-medium);
      background: var(--bg-secondary);
    `}
`

export const CalendarWrapper = styled.div`
  width: 100%;
  padding: var(--space-300);

  ${mediaQueries.tablet} {
    width: 600px;
    padding: var(--space-100) var(--space-100) var(--space-100) 0;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: var(--space-n200);
      top: var(--space-n100);
      height: calc(100% + var(--space-100));
      width: 1px;
      background: var(--border-secondary);
    }
  }
`

export const Footer = styled.div`
  display: flex;
  gap: var(--space-400);
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  padding: var(--space-400) var(--space-300) var(--space-300);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: var(--space-n100);
    top: 0;
    width: calc(100% + 2 * var(--space-100));
    height: 1px;
    background: var(--border-secondary);
  }

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: var(--space-300);
    padding: var(--space-200) var(--space-100) var(--space-100) var(--space-300);
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-300);
  width: 100%;

  ${mediaQueries.tablet} {
    gap: var(--space-400);
    flex-direction: row;
    width: auto;
  }
`

export const DateRangeLabel = styled.div`
  font-size: var(--font-size-300);
  flex: 1;

  ${mediaQueries.tablet} {
    font-size: var(--font-size-400);
  }
`
